<template>
  <v-container class="page-content px-5" style="width: 100%">
    <VisitorDetail
      v-if="this.loading"
      :item="item"
    >
      <template v-slot:btn>
        <v-btn
            @click="returnParent()" class="dark-primary" icon small
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if="$vuetify.breakpoint.xsOnly"
            icon
            class="mr-0 dark-primary"
            @click="editVisitor"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-toolbar-items  v-if="$vuetify.breakpoint.smAndUp">
          <v-btn
              text
              @click="editVisitor"
              class="rounded-tr-lg dark-primary"
          >
            Редактировать посетителя
          </v-btn>
        </v-toolbar-items>
      </template>
    </VisitorDetail>
    <v-skeleton-loader
        v-else
        type="table-heading, list-item-three-line"
    ></v-skeleton-loader>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :edit="edit_status"
        :visitor-data="visitor_data"
        @close="closeEditDialog"
    ></EditDialog>
  </v-container>
</template>

<script>
import TitledPageMixin from "@/mixins/TitledPageMixin";
import names from "@/modules/admin/routers/names";
import {mapActions, mapGetters} from "vuex";
import EditDialog from "@/modules/admin/visitors/components/VisitorsEditDialog";
import VisitorDetail from "@/modules/templates/VisitorDetail";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";

export default {
  name: "AdminVisitorsDetail",
  mixins: [TitledPageMixin],
  components: {EditDialog, VisitorDetail},
  data() {
    return {
      loading: false,
      page_title: "Детальное представление посетителя",
      dialog_add_edit: false,
      edit_status: undefined,
      visitor_data: undefined
    }
  },
  computed: {
    ...mapGetters({
      item: "admin/getVisitorsDetail"
    })
  },
  methods: {
    ...mapActions({
      loadVisitorDetail: "admin/loadVisitorsDetail"
    }),
    returnParent() {
      this.$router.push({name: names.VISITORS.LIST}).catch(() => {})
    },
    loadData(url=undefined){
      this.loadVisitorDetail({
        url: url,
        id: this.$route.params.idVisitors,
        finalizer: (val) => {
          this.loading = true
        }
      })
    },
    editVisitor() {
      this.dialog_add_edit = true
      this.edit_status = true
      let newItem = Object.assign({}, this.item)
      delete newItem.cars
      this.visitor_data = newItem
    },
    closeEditDialog() {
      this.loadData()
      this.dialog_add_edit = false
      this.edit_status = undefined
      this.visitor_data = undefined
    }
  },
  created () {
    if (admin.ADMIN.ALLOWED()){
      this.loadData(undefined)
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
